import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, List, Badge } from "reactstrap";
import { useAuth0 } from "react-auth0-spa";
import AgentService from "core/api/AgentService";
import { UserContext } from "context/UserContext";
import { MainDeviceContext } from "context/MainDeviceContext";
import { SignalRNotificationContext } from "context/SignalRNotificationContext";
import DraggableBox from "./DraggableBox";

export default function CallCenterStatus() {
    const statusWidth = 310;
    const [onlineAgents, setOnlineAgents] = useState([])
    const [showOnlineAgents, setShowOnlineAgents] = useState(false)
    const [statusMenuOpen, setStatusMenuOpen] = useState(false)
    const [savingStatus, setSavingStatus] = useState(false)
    const [statusBoxPosition, setStatusBoxPosition] = useState({ x: 30, y: 65 })
    const [onlineAgentsBoxPosition, setOnlineAgentsBoxPosition] = useState({})
    const statusBoxRef = useRef(null)

    const { userData, setUserStatus } = useContext(UserContext)
    const { deviceData } = useContext(MainDeviceContext)
    const { connectionStatus, dispatchRegistrationStatus } = useContext(SignalRNotificationContext)
    const { user } = useAuth0();

    const statusOptions = userData.status == "Offline" || userData.status == "Busy" ? ["Online"] : ["Online", "Break", "Offline"]

    const dispatchNotificationStatus = dispatchRegistrationStatus === "error" ? "Error"
        : userData.status == "Break" ? "Paused"
            : userData.status !== "Online" && userData.status !== "Busy" ? "Offline"
            : connectionStatus === "reconnecting" ? "Reconnecting"
                : connectionStatus === "error" ? "Error"
                    : connectionStatus !== "connected" ? "Disconnected"
                        : dispatchRegistrationStatus === "registered" ? "Registered"
                            : dispatchRegistrationStatus === "registering" ? "Registering"
                                : "Not registered";

    const moveAgentBoxBasedOnStatusBox = (newStatusBoxPositions) => {
        setStatusBoxPosition(newStatusBoxPositions);
    }

    useLayoutEffect(() => {
        if (!showOnlineAgents) return;

        const updatePosition = () => {
            const box = statusBoxRef.current;
            const beside = box.getBoundingClientRect().right + 20 + box.offsetWidth <= window.innerWidth;
            setOnlineAgentsBoxPosition({
                left: beside ? box.offsetLeft + box.offsetWidth + 20 : box.offsetLeft,
                top: beside ? box.offsetTop : box.offsetTop + box.offsetHeight + 12,
                width: box.offsetWidth
            });
        };

        updatePosition();
        window.addEventListener("resize", updatePosition);
        return () => window.removeEventListener("resize", updatePosition);
    }, [showOnlineAgents, statusBoxPosition]);

  
    const changeStatus = async (status) => {
        if (savingStatus || status == userData.status || (userData.status == "Busy" && status != "Online")) return;

        setStatusMenuOpen(false)
        setSavingStatus(true)
        try {
            await AgentService.addUserLog({ UserEmail: user.email, LogDate: new Date(), Status: status })
            setUserStatus(status)
        } catch (err) {
            console.error("Failed to update user status:", err)
        } finally {
            setSavingStatus(false)
        }
    }

    useEffect(() => {

        async function fetchData() {
            const onlineUsers = await AgentService.getActiveUsers(new Date().toISOString(), true)
            setOnlineAgents(onlineUsers.model)
            if (onlineUsers.model.length === 0) setShowOnlineAgents(false)
        }

        fetchData();
        const interval = setInterval(() => {
            fetchData()
        }, 15000)

        return () => { clearInterval(interval) }

    }, [])


    return (
        <div>
            <DraggableBox boxRef={statusBoxRef} defaultX={statusBoxPosition.x} defaultY={statusBoxPosition.y} onPositionChange={moveAgentBoxBasedOnStatusBox} style={{ backgroundColor: userData.status == "Offline" ? "red" : userData.status == "Break" ? "#ffc107" : "green", color: userData.status == "Break" ? "#212529" : "white", width: statusWidth, maxWidth: "calc(100vw - 40px)", minHeight: 110, padding: 10 }}>
                <div >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 6 }}>
                        <div className="title" style={{ fontSize: 16 }}>Call Center Status</div>

                        <div
                            onMouseDown={event => event.stopPropagation()}
                            onTouchStart={event => event.stopPropagation()}
                            style={{ flexShrink: 0 }}
                        >
                            <Dropdown isOpen={statusMenuOpen} toggle={() => {
                                if (!savingStatus) setStatusMenuOpen(open => !open)
                            }}>
                                <DropdownToggle
                                    caret
                                    disabled={savingStatus}
                                    style={{ backgroundColor: "#f8f9fa", color: "#212529", border: "1px solid #dee2e6", borderRadius: 5, margin: 0, padding: "3px 6px", minHeight: 0, height: "auto", fontSize: 12, lineHeight: "16px", fontWeight: 700, opacity: 1, boxShadow: "none" }}
                                >
                                    {userData.status}
                                </DropdownToggle>
                                <DropdownMenu end style={{ minWidth: "100%", width: "100%", padding: 2, borderRadius: 5, boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)" }}>
                                    {statusOptions.filter(status => status != userData.status).map(status => (
                                        <DropdownItem key={status} toggle={false} onClick={() => changeStatus(status)} style={{ margin: 0, padding: "3px 8px", height: "auto", minHeight: 0, minWidth: 0, fontSize: 12, lineHeight: "16px", textAlign: "left", borderRadius: 3 }}>
                                            {status}
                                        </DropdownItem>
                                    ))}
                                </DropdownMenu>
                            </Dropdown>
                        </div>

                </div>

                    <div id="numOnlineAgents" style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        {`Online Agents: ${onlineAgents.filter(agent => agent.status == "Online" || agent.status == "Busy").length}`}
                        {onlineAgents.length > 0 && <button
                            type="button"
                            style={{ border: 0, borderRadius: 4, backgroundColor: showOnlineAgents ? "rgba(0,0,0,.22)" : "rgba(255,255,255,.18)", boxShadow: showOnlineAgents ? "inset 0 1px 2px rgba(0,0,0,.25)" : "none", color: "inherit", fontSize: 12, lineHeight: "24px", height: 24, minWidth: 0, margin: 0, padding: "0 7px", cursor: "pointer" }}
                            onMouseDown={(event) => event.stopPropagation()}
                            onTouchStart={(event) => event.stopPropagation()}
                            onClick={() => setShowOnlineAgents(!showOnlineAgents)}
                        >
                            View
                        </button>}
                    </div>


                <div> Device Status: {deviceData.deviceStatus.charAt(0).toUpperCase() + deviceData.deviceStatus.slice(1)}</div>
                    <div>Dispatch Alerts Status: {dispatchNotificationStatus}</div>

            </div>
            </DraggableBox>

            {showOnlineAgents && onlineAgents.length > 0 &&
                <div style={{ backgroundColor: "white", position: "absolute", ...onlineAgentsBoxPosition, padding: 10, color: "black" }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontWeight: "bold" }}>
                        <div>Agents</div>
                        <button type="button" style={{ border: 0, backgroundColor: "transparent", color: "black", fontSize: 20, lineHeight: "24px", height: 24, minWidth: 24, margin: 0, padding: "0 5px", cursor: "pointer" }} onClick={() => setShowOnlineAgents(false)}>×</button>
                    </div>
                    <List type="unstyled" style={{ margin: 0 }}>
                        {onlineAgents?.map((agent, index) => (
                            <li key={index}>
                                {agent.userEmail}
                                {agent.status == "Busy" && <Badge color="info">Busy</Badge>}
                                {agent.status == "Online" && <Badge color="success">Ready</Badge>}
                                {agent.status == "Break" && <Badge color="warning" >Break</Badge>}

                            </li>
                        ))}
                    </List>
                </div>
            }

        </div>

    )
}